import React from 'react';
import { Link } from 'react-router-dom';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground py-16 px-6">
      <div className="max-w-3xl mx-auto">
        {/* Logo / Back link */}
        <Link to="/" className="inline-flex items-center space-x-3 mb-12 hover:opacity-80 transition-opacity">
          <img
            src="/brand/depthme-icon-192.png"
            alt="DepthMe Logo"
            className="w-10 h-10 object-contain"
          />
          <span className="text-lg font-semibold text-foreground">DepthMe</span>
        </Link>

        <h1 className="text-4xl font-bold text-foreground mb-2">Terms of Service</h1>
        <p className="text-sm text-muted-foreground/60 mb-10">Last updated: April 2026</p>

        <div className="glassmorphism rounded-2xl p-8 space-y-8">

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Acceptance of Terms</h2>
            <p className="text-muted-foreground leading-relaxed">
              By creating an account or using DepthMe, you agree to these Terms of Service. If you do not agree, please do not use the app.
            </p>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Description of Service</h2>
            <p className="text-muted-foreground leading-relaxed">
              DepthMe is a personal growth and spiritual guidance application that provides AI-generated daily guidance, ritual session tools, journaling, and progress tracking. It is intended for personal reflection and self-awareness purposes only.
            </p>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Not a Substitute for Professional Care</h2>
            <p className="text-muted-foreground leading-relaxed">
              DepthMe does not provide medical, psychological, psychiatric, or legal advice. All guidance is intended to support self-awareness and personal reflection — not to replace professional healthcare, therapy, or counselling. If you are experiencing a mental health crisis, please contact a qualified professional or emergency services.
            </p>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Your Account</h2>
            <ul className="list-disc pl-5 space-y-1 text-muted-foreground">
              <li>You must be at least 13 years of age to use DepthMe.</li>
              <li>You are responsible for maintaining the security of your account credentials.</li>
              <li>You are responsible for all activity that occurs under your account.</li>
              <li>You agree to provide accurate information during registration.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Acceptable Use</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
              You agree to use DepthMe for personal growth and reflection purposes only. You must not:
            </p>
            <ul className="list-disc pl-5 space-y-1 text-muted-foreground">
              <li>Attempt to reverse-engineer or copy the app</li>
              <li>Use the app in any way that violates applicable laws</li>
              <li>Share your account with others</li>
            </ul>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Subscriptions and Payments</h2>
            <p className="text-muted-foreground leading-relaxed">
              DepthMe offers free and premium subscription tiers. Paid subscriptions are billed through Stripe. A 7-day free trial is available for new premium subscribers. Subscriptions automatically renew unless cancelled before the renewal date. Refunds are handled on a case-by-case basis — contact{' '}
              <a href="mailto:hello@depthme.app" className="text-primary hover:underline">
                hello@depthme.app
              </a>.
            </p>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Intellectual Property</h2>
            <p className="text-muted-foreground leading-relaxed">
              All content, design, and AI-generated guidance within DepthMe is the property of DepthMe. Your personal journal entries remain your own.
            </p>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Changes to the Service</h2>
            <p className="text-muted-foreground leading-relaxed">
              DepthMe may update, modify, or discontinue features at any time. We will provide reasonable notice of significant changes.
            </p>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Limitation of Liability</h2>
            <p className="text-muted-foreground leading-relaxed">
              DepthMe is provided "as is". To the fullest extent permitted by law, we are not liable for any indirect, incidental, or consequential damages arising from your use of the app.
            </p>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Governing Law</h2>
            <p className="text-muted-foreground leading-relaxed">
              These terms are governed by the laws of the jurisdiction in which DepthMe operates.
            </p>
          </div>

          <div>
            <h2 className="text-base font-semibold text-accent mb-3">Contact</h2>
            <p className="text-muted-foreground leading-relaxed">
              For questions about these terms:{' '}
              <a href="mailto:hello@depthme.app" className="text-primary hover:underline">
                hello@depthme.app
              </a>
            </p>
            <p className="mt-4 text-sm text-muted-foreground/50">
              See also:{' '}
              <Link to="/privacy" className="text-primary hover:underline">
                Privacy Policy
              </Link>
            </p>
          </div>

        </div>

        <Link to="/" className="inline-flex items-center space-x-2 mt-10 text-sm text-primary hover:underline">
          <span>←</span>
          <span>Back to DepthMe</span>
        </Link>
      </div>
    </div>
  );
};

export default TermsPage;
